module.exports = __webpack_public_path__ + "d308073b/img/product-icon-grey.b248963c.svg";